import React from 'react';
import WidgetReference from './WidgetReference';

export default function AccountExtensionGuide() {
  return (
    <>
      <WidgetReference guideId="account-ext" />
    <iframe
      src="https://scribehow.com/shared/Add_The_Customer_Account_Extension_non-legacy_accounts__0vPwtAGuQzydObARmUsiEA"
      height="640"
      title="Account Extension"
      allowFullScreen
    />
    </>
  );
}
